import * as React from "react";
export const renderStartTime = (eventTime, dict, componentPrefix) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}__start-time` },
    React.createElement("span", { className: `rj-ev-list__${componentPrefix}__start` }, dict.StartedAt),
    React.createElement("span", { className: `rj-ev-list__${componentPrefix}__time` }, eventTime));
//# sourceMappingURL=renderStartTime.js.map